class @App.Components.Mobilenav
  constructor: ->
    @$html = $('html')
    @$body = $('body')
    @isOpen = false
    @$mobilenav = $('[data-component="mobilenav"]').first()

    @$body.on 'App::Components::Mobilenav::toggle', =>
      @toggle()
      return

    @$body.on 'click', '[data-mobilenav="toggle"]', (e) =>
      e.preventDefault()
      @toggle()
      return

    # blur the shop, (or any target=_blank) link after it's clicked
    @$mobilenav.on 'click', 'a[target="shop"], a[target="_blank"]', () =>
      setTimeout (() =>
        $(this).blur()
        @toggle()
      ), 250

  toggle: () =>
    state = if @isOpen then 'close' else 'open'
    @isOpen = !@isOpen

    if $('.iframed-blog-header').length
      # We're in the blog header
      # Let the parent window know when this is opened/closed so it can alter z-index of the iframe
      window.parent.postMessage({ event: 'user_action_dropdown_toggle', status: state }, 'https://blog.ed.ted.com')

    @$body.trigger 'App::Components::Mobilenav::' + state
    @$body.toggleClass 'tdd-navpane--is-open tdd-navpane--noscroll', @isOpen
    @$html.toggleClass 'tdd-navpane--noscroll', @isOpen
    $('[data-mobilenav="toggle"]').toggleClass 'is-active', @isOpen
    $('[data-component="mobilenav"]').toggleClass 'is-open', @isOpen
    $('[data-mobilenav="hide"]').toggle(!@isOpen)
    if @isOpen
      $('[data-component="main-navbar"]').hide()
      $('[data-component="mobilenav"]').focus()
    else
      $('[data-component="main-navbar"]').show()
      $('[data-component="mobilenav"], [data-component="mobilenav"] :focus').blur()
    return

$ ->
  new App.Components.Mobilenav
